import type { CalendarsConfig } from "../Models/Domain";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { updateConfig } from "@/Services/TherapyApi/Calendars";
import CalendarConfigTransformer from "@/Modules/Transformers/Calendars/Config";

import useCalendarsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

import { danger } from "@/Utils/Debug";

const updateConfigActionHandler = async (): Promise<CalendarsConfig> => {
  const calendarsStore = useCalendarsStore();
  const appStore = useAppStore();

  try {
    const config = await updateConfig(CalendarConfigTransformer.toApi(calendarsStore.config!));

    calendarsStore.config = CalendarConfigTransformer.toDomain(config);

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "calendars.menu.config.advice_policy.save_success",
    });
  } catch (e) {
    danger("Error updating config", e);

    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "calendars.menu.config.advice_policy.save_error",
    });
  }

  return calendarsStore.config!;
};

export default updateConfigActionHandler;
